import Bookmark from './bookmark'

const bookmark = new Bookmark()
bookmark.init()
